export default {
    listagem: {
        titulo_pagina: 'Lista de Tempos',
        novo: 'Criar novo Tempo',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Tempo encontrado',
            nome: 'Nome',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Tempo',
            editar: 'Editar Tempo'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código do Tempo'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Tempo'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Tempo'
            },
            botao_salvar : 'Salvar Tempo'
        },
        create: {
            success: 'Tempo criado com Sucesso!',
            error: 'Error ao criar Tempo!'
        },
        update: {
            success: 'Tempo editado com Sucesso!',
            error: 'Error ao editar Tempo!'
        }
    }
}
